"use client";

import { c as _c } from "react/compiler-runtime";
import { useDateLocale } from "@/app/[lng]/_components/datelocale-context";
import { useLocaleContext } from "@/app/i18n/client";
import { LocaleName } from "@/app/i18n/settings";
import { formatFullDate, formatLocalDateDateFns, formatLocalDateTimeDateFns } from "@/constants/constants";
import { formatPrice } from "@/lib/formatting";
import { formatDate } from "date-fns";
import { formatInTimeZone, fromZonedTime, getTimezoneOffset } from "date-fns-tz";
import { useEffect, useState } from "react";
export function useDateTimeFormatter() {
  const $ = _c(2);
  const locale = useDateLocale();
  let t0;
  if ($[0] !== locale) {
    t0 = date => {
      const newTime = fromZonedTime(date, "Europe/Berlin");
      return formatDate(newTime, formatFullDate, {
        locale
      });
    };
    $[0] = locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function useDateFormatter() {
  const $ = _c(2);
  const locale = useDateLocale();
  let t0;
  if ($[0] !== locale) {
    t0 = date => formatInTimeZone(date, "Europe/Berlin", formatFullDate, {
      locale
    });
    $[0] = locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function useStripePriceFormatted(amount, currency) {
  const $ = _c(9);
  const lng = useLocaleContext();
  let t0;
  if ($[0] !== amount || $[1] !== currency || $[2] !== lng) {
    t0 = formatPrice(lng, amount, currency);
    $[0] = amount;
    $[1] = currency;
    $[2] = lng;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const [formattedPrice, setFormattedPrice] = useState(t0);
  let t1;
  let t2;
  if ($[4] !== amount || $[5] !== currency || $[6] !== lng) {
    t1 = () => {
      setFormattedPrice(formatPrice(lng, amount, currency));
    };
    t2 = [lng, amount, currency];
    $[4] = amount;
    $[5] = currency;
    $[6] = lng;
    $[7] = t1;
    $[8] = t2;
  } else {
    t1 = $[7];
    t2 = $[8];
  }
  useEffect(t1, t2);
  return formattedPrice;
}